import { SvgIcon, SvgIconProps } from "@commonlibs";
import clsx from "clsx";

export default function LinkIcon({ className, ...rest }: Omit<SvgIconProps, "children">): JSX.Element {
    return (
        <SvgIcon {...rest} data-testid="LinkIcon" className={clsx(undefined, "Icon", className)} fill="none">
            <path
                d="M14.5 5C13.9477 5 13.5 4.55228 13.5 4C13.5 3.44772 13.9477 3 14.5 3H20.5C20.7652 3 21.0196 3.10536 21.2071 3.29289C21.3946 3.48043 21.5 3.73478 21.5 4L21.5 10C21.5 10.5523 21.0523 11 20.5 11C19.9477 11 19.5 10.5523 19.5 10L19.5 6.41422L10.2071 15.7071C9.81658 16.0976 9.18342 16.0976 8.79289 15.7071C8.40237 15.3166 8.40237 14.6834 8.79289 14.2929L18.0858 5H14.5ZM3.5 7C3.5 5.89543 4.39543 5 5.5 5H10.5C11.0523 5 11.5 5.44772 11.5 6C11.5 6.55228 11.0523 7 10.5 7H5.5V19H17.5V14C17.5 13.4477 17.9477 13 18.5 13C19.0523 13 19.5 13.4477 19.5 14V19C19.5 20.1046 18.6046 21 17.5 21H5.5C4.39543 21 3.5 20.1046 3.5 19V7Z"
                fill="#43398E"
            />
        </SvgIcon>
    );
}
